import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('mermaids_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('mermaids_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('mermaids_cookie_consent', 'declined');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.95 }}
          transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          className="fixed bottom-6 left-6 right-6 md:right-auto md:max-w-md z-50 bg-[#2B1218] text-[#FAF3E0] p-6 rounded-3xl border border-[#FFA5C1]/30 shadow-2xl backdrop-blur-lg"
        >
          <button
            onClick={handleDecline}
            className="absolute top-4 right-4 text-white/50 hover:text-white transition-colors p-1 rounded-full hover:bg-white/10"
            aria-label="Close cookie banner"
          >
            <X className="w-4 h-4" />
          </button>

          <div className="flex items-start gap-4 mb-4">
            <div className="w-11 h-11 rounded-2xl bg-[#F14909] text-white flex items-center justify-center shrink-0 shadow-lg shadow-[#F14909]/30">
              <Cookie className="w-6 h-6" />
            </div>
            <div>
              <h3 className="font-heading text-lg text-white font-bold mb-1 flex items-center gap-2">
                We Value Your Privacy
                <ShieldCheck className="w-4 h-4 text-[#FFA5C1]" />
              </h3>
              <p className="font-body text-xs text-[#FAF3E0]/80 leading-relaxed font-light">
                Mermaids Only Hostel uses cookies to enhance your surfing experience, remember your preferences, and ensure seamless bookings. Read our{' '}
                <Link to="/terms" className="text-[#FFA5C1] underline hover:text-white transition-colors font-medium">
                  Privacy & Terms
                </Link>.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-end gap-3 pt-2">
            <button
              onClick={handleDecline}
              className="px-4 py-2 rounded-full border border-white/20 text-white/80 hover:text-white hover:border-white/40 text-xs font-body font-semibold transition-all"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="btn-primary !px-6 !py-2 !text-xs !shadow-md hover:scale-105 transition-transform"
            >
              Accept All 🌸
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
